import { render, staticRenderFns } from "./LogoPartner.vue?vue&type=template&id=1820cd03&"
import script from "./LogoPartner.vue?vue&type=script&lang=js&"
export * from "./LogoPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports